import actions from '../../actionTypes';

export default () => {
  return {
    type: actions.RESEND_VERIFY_HIDE_MODAL
  };
};


// WEBPACK FOOTER //
// ./src/reducers/auth/actions/resendVerifyModalHide.js